import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppRoutes, MODAL_TOKEN, ModalProvider, TeamsRoutes } from '@core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-push-create-group',
  templateUrl: './create-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class CreateGroupComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly router: Router = inject(Router);

  handleAction(): void {
    this.modalProvider.dismissAllStoredModals();
    this.router.navigateByUrl(`${AppRoutes.TEAMS}/${TeamsRoutes.CREATE}`);
  }

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
